import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Icon from 'src/components/ui/Icon/Icon';
// import Search from 'src/components/ui/Search/Search';
import NotificationCenterModal from 'src/components/modals/NotificationCenterModal/NotificationCenterModal';
import { Link } from 'react-router-dom';
import { useOutsideClick } from 'src/hooks/utils';
import useNotifications from 'src/services/notification';
import styles from './NavHeader.module.scss';

export type NavHeaderProps = {
  expanded: boolean;
};

export const NavHeader: React.FC<NavHeaderProps> = ({ expanded }) => {
  const notificationModalRef = useRef<HTMLDivElement>(null);
  const { unreadCount, fetchUnreadCount } = useNotifications();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState<boolean>(false);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      notificationModalRef.current &&
      !notificationModalRef.current.contains(event.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setIsNotificationModalOpen(false);
    }
  };

  // register click outside event to close the menu
  useOutsideClick(notificationModalRef, handleClickOutside);

  const handleNotificationsUpdate = () => {
    fetchUnreadCount();
  };

  const handleButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsNotificationModalOpen(prevState => !prevState);
  };

  const onMenuClose = () => {
    document.body.classList.remove('menu-active');
  };

  // Set interval to fetch unread count
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUnreadCount();
    }, 20000);

    return () => clearInterval(intervalId);
  }, [fetchUnreadCount]);

  return (
    <>
      <div
        className={classNames(styles.root, 'flex items-center gap-11', {
          'flex-col px-12 pt-12': !expanded,
          'p-20': expanded,
        })}>
        {expanded ? (
          <Link to="/">
            <Icon name="logo-full-white" width={91} height={30} />
          </Link>
        ) : (
          <Link to="/" className="surface-elevated--dark border-subtle--dark rounded-base p-5 w-full">
            <Icon name="logo-compact" width={28} height={28} />
          </Link>
        )}
        <div
          className={classNames(
            !expanded && styles.notificationRootCollapsed,
            'cursor-pointer relative flex items-center hover:surface-elevated--dark',
            { 'ml-auto': expanded },
          )}>
          <button
            ref={buttonRef}
            type="button"
            onClick={handleButtonClick}
            aria-label="Open Notifications"
            className={`${isNotificationModalOpen && styles.open}`}>
            {unreadCount > 0 ? (
              <Icon
                name="notificationsActive"
                height={expanded ? 28 : 20}
                width={expanded ? 28 : 20}
                className="text-white"
              />
            ) : (
              <Icon
                name="notifications"
                height={expanded ? 28 : 20}
                width={expanded ? 28 : 20}
                className="text-white"
              />
            )}
          </button>
          <div className={styles.notificationModal} ref={notificationModalRef}>
            <NotificationCenterModal
              isOpen={isNotificationModalOpen}
              onClose={() => setIsNotificationModalOpen(false)}
              onNotificationsUpdate={handleNotificationsUpdate}
            />
          </div>
        </div>
        <button className="md:hidden" type="button" onClick={onMenuClose} aria-label="close menu">
          <Icon width={20} height={20} name="close" className="text-white" />
        </button>
      </div>
      <div
        className={classNames('flex items-center justify-center w-full', {
          'px-12 pb-20': expanded,
          'px-12 mt-2': !expanded,
        })}>
        {/* <Search expanded={expanded} /> */}
      </div>
      {!expanded && <div className="border-subtle--dark border-t-1 my-8" aria-hidden />}
    </>
  );
};
